import { render } from "./FileViewFull.vue?vue&type=template&id=4178f452&scoped=true"
import script from "./FileViewFull.vue?vue&type=script&lang=js"
export * from "./FileViewFull.vue?vue&type=script&lang=js"

import "./FileViewFull.vue?vue&type=style&index=0&id=4178f452&lang=scss&scoped=true"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4178f452"]])

export default __exports__